module.exports = __webpack_public_path__ + "img/390.8ead4925.jpg";